/* eslint-disable react/prop-types */
import React, { View, Text, TouchableOpacity, Image } from 'react-native'
import { commonStyle } from '../../assets/TextStyles/TextStyles'
import { playSound } from '../../utils/AudioPlayer'

const Pilots = (props) => {
  const openInfo = (infoPage) => {
    props.openInfo(infoPage)
    playSound(import('../../assets/sounds/confirm.mp4'))
  }

  return (
    <View style={{ alignItems: 'left' }}>
      <Text style={commonStyle.h2}>Pilottiprojektit</Text>
      <Image
        style={{ position: 'absolute', right: 40, top: 40, width: 109, height: 74 }}
        source={require('../../assets/symbols/animated_gif.gif')}
      />
      <Text style={commonStyle.h4}>Liikenne</Text>
      <TouchableOpacity onPress={() => openInfo('robottibusseja')}>
        <Text style={commonStyle.link}>Robottibussit</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => openInfo('sahkoautoja')}>
        <Text style={commonStyle.link}>Sähköautot</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => openInfo('sahkobussit')}>
        <Text style={commonStyle.link}>Sähköbussit</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => openInfo('yhteiskayttoautoja')}>
        <Text style={commonStyle.link}>Yhteiskäyttöautot</Text>
      </TouchableOpacity>

      <Text style={commonStyle.h4}>Jätehuolto</Text>
      <TouchableOpacity onPress={() => openInfo('metaani_talteenotto')}>
        <Text style={commonStyle.link}>Metaanin vähentäminen suljetuilta kaatopaikoilta</Text>
      </TouchableOpacity>

      <Text style={commonStyle.h4}>Yksityiset asunnot</Text>
      <TouchableOpacity onPress={() => openInfo('aurinko_kerrostaloihin')}>
        <Text style={commonStyle.link}>Aurinkosähköä kerrostaloihin</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => openInfo('aurinko_pientaloihin')}>
        <Text style={commonStyle.link}>Aurinkosähköä pientaloihin</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => openInfo('kaukolammon_ohjaus')}>
        <Text style={commonStyle.link}>Kaukolämmön älykäs ohjaus</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => openInfo('maalampo_pientaloihin')}>
        <Text style={commonStyle.link}>Maalämpöä pientaloihin</Text>
      </TouchableOpacity>

      <Text style={commonStyle.h4}>Julkiset tilat</Text>
      <TouchableOpacity onPress={() => openInfo('hoivarakennus_nollaenergia')}>
        <Text style={commonStyle.link}>Hoivakodit nollaenergiataloiksi</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => openInfo('maalampo_aurinko_kouluihin')}>
        <Text style={commonStyle.link}>Maalämpö ja aurinkokeräimet kouluihin</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => openInfo('paastotonta_sahkoa_kysyntajousto')}>
        <Text style={commonStyle.link}>Kysyntäjousto</Text>
      </TouchableOpacity>

      <Text style={commonStyle.h4}>Voimalaitokset</Text>
      <TouchableOpacity onPress={() => openInfo('biokaasua_biojatteesta')}>
        <Text style={commonStyle.link}>Biokaasua biojätteestä</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => openInfo('kaukolampo_datakeskuksesta')}>
        <Text style={commonStyle.link}>Kaukolämpö datakeskuksesta</Text>
      </TouchableOpacity>
    </View>
  )
}

export default Pilots
